interface InquiryData {
  dataForInquiry: string[];
  inquiryUrl: string;
}

export function sendInquiryDataInRedirect(props: InquiryData) {
  if (props.dataForInquiry.length > 0) {
    let partialQueryString = "?";
    partialQueryString += props.dataForInquiry.join(",");
    const newUrl = props.inquiryUrl + partialQueryString;
    window.location.assign(newUrl);
  }
}
